import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { addResourceHints, registerServiceWorker } from './utils/bundleOptimization';

// Add resource hints for better performance
addResourceHints();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for caching
registerServiceWorker();

// Enhanced web vitals reporting
reportWebVitals((metric) => {
  // Log performance metrics in development
  if (process.env.NODE_ENV === 'development') {
    console.log('Web Vital:', metric);
  }
  
  // In production, you could send to analytics
  // analytics.track('Web Vital', metric);
});
